import type { Interest } from '../entities/interest.entity'
import type { InterestRepository, ListInterestsParams } from '../repositories/interest_repository'

export class ListInterestsUseCase {
  constructor(private readonly repository: InterestRepository) {}

  execute(params?: ListInterestsParams): Promise<Interest[]> {
    return this.repository.list(params)
  }
}
